import { REACT_APP_API } from '../../config'
import axios from 'axios'
import {generateLabelToShow} from '../../../features/dashboard/utils/generateLabelToShow'

export default async function generatePDF(reportName, selectedAttribute, attributeList, dataValues, columnData, selectedHeaders, urlParams) {
    
    selectedHeaders.date_label = generateLabelToShow(selectedHeaders.filterDate.actual_from, selectedHeaders.filterDate.actual_to)

    const body = JSON.parse(JSON.stringify({
        selectedAttribute,
        attributeList,
        dataValues,
        columnData,
        selectedHeaders, 
        urlParams
    }))

    if(!body.selectedHeaders.filters.car_lot_name.length > 0){
        const carlotsList = await axios.get(`${REACT_APP_API}/dashboard-utils/car_lots?${urlParams}`)
        body.selectedHeaders.filters.car_lot_name = carlotsList.data.values
    }
    
    if(!body.selectedHeaders.filters.branch_office_name.length > 0){
        const branchOfficesList = await axios.get(`${REACT_APP_API}/dashboard-utils/branch_offices?${body.selectedHeaders.filters.car_lot_name.reduce((prev, next) => (`${prev===''?prev:`${prev}&`}car_lots[]=${next}`), '')}&${urlParams}`)
        body.selectedHeaders.filters.branch_office_name= branchOfficesList.data.values
    }

    const {data} = await axios({
        method: 'post',
        url: `${REACT_APP_API}/dashboard/generatePDF/${reportName}`,
        data: body,
        timeout: 300000, // 5 minutos
        responseType: 'text/html'
    })
    if(data){
        const file = new Blob([data], { type: 'text/html' })
        const fileURL = URL.createObjectURL(file)
        window.open(fileURL, "_blank")
        return true
    } else return null
}